import React from 'react';
import './filters.css';
import { SystemText } from '@salesperformanceint/e4shared';

export const Filter = ({ filters, onFilter }) => {
    const outer = React.useRef(null);
    const [show, setShow] = React.useState(false);
    const [values, setValues] = React.useState({});
    const [open, setOpen] = React.useState(null);
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        const handleClick = e => {
            if (!outer.current?.contains(e.target)) {
                setShow(false);
            }
        };
        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        };
    }, []);

    const toggleValue = (ref, val) => {
        let temp = { ...values };
        temp[ref] = temp[ref] || [];
        if (temp[ref].some(x => x === val)) {
            temp[ref] = temp[ref].filter(x => x !== val);
            setCount(count - 1);
        } else {
            temp[ref] = temp[ref].concat([val]);
            setCount(count + 1);
        }

        const newValues = { ...values };
        newValues[ref] = temp[ref];
        setValues(newValues);
    };

    const hasValue = (ref, val) => {
        const temp = values[ref] || [];
        return temp.some(x => x === val);
    };

    if (!filters?.length) return null;

    const st = (path, ...rest) => SystemText(`General/Filter/${path}`, ...rest);

    return (
        <div ref={outer} className="insights-filter" data-testid="filter-dropdown">
            <button className="btn flex flex-center" onClick={() => setShow(!show)} title={st('Title')}>
                <i className="fa fa-bars-filter" />
                {count > 0 && (
                    <label className="text-xs label label-danger" style={{ margin: '0 0 0 5px' }}>
                        {count}
                    </label>
                )}
            </button>
            {show && (
                <div className="filter-options-container">
                    <div className="filter-options">
                        {filters.map(f => {
                            const isOpen = open === f.ref;
                            return (
                                <>
                                    <div
                                        className="pointer flex flex-center"
                                        key={`filter-area-${f.ref}`}
                                        onClick={() => (open === f.ref ? setOpen('') : setOpen(f.ref))}
                                    >
                                        <div className="flex-grow bold">
                                            {f.label}
                                            {values[f.ref]?.length > 0 && (
                                                <span className="ml5">({values[f.ref]?.length})</span>
                                            )}
                                        </div>
                                        <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} />
                                    </div>
                                    {isOpen && (
                                        <span className="scrollable">
                                            {f.boolean ? (
                                                <>
                                                    <div
                                                        className="flex flex-center pointer"
                                                        onClick={() => toggleValue(f.ref, true)}
                                                    >
                                                        <i
                                                            className={`fa fa-square${
                                                                hasValue(f.ref, true) ? '-check fa-solid' : ''
                                                            } mr10`}
                                                        />
                                                        {st('Yes')}
                                                    </div>
                                                    <div
                                                        className="flex flex-center pointer"
                                                        onClick={() => toggleValue(f.ref, false)}
                                                    >
                                                        <i
                                                            className={`fa fa-square${
                                                                hasValue(f.ref, false) ? '-check fa-solid' : ''
                                                            } mr10`}
                                                        />
                                                        {st('No')}
                                                    </div>
                                                </>
                                            ) : (
                                                f.data.map(x => (
                                                    <div
                                                        className="flex flex-center pointer"
                                                        onClick={() => toggleValue(f.ref, x.id)}
                                                    >
                                                        <i
                                                            className={`fa fa-square${
                                                                hasValue(f.ref, x.id) ? '-check fa-solid' : ''
                                                            } mr10`}
                                                        />
                                                        {x.name}
                                                    </div>
                                                ))
                                            )}
                                        </span>
                                    )}
                                </>
                            );
                        })}
                        <div className="flex flex-center">
                            <button
                                className="btn btn-primary flex flex-center"
                                onClick={() => {
                                    onFilter(values);
                                    setShow(false);
                                }}
                            >
                                {st('Apply')}
                            </button>
                            <span className="flex-grow text-right">
                                <button
                                    className="btn btn-link"
                                    disabled={!count}
                                    onClick={() => {
                                        setValues({});
                                        onFilter({});
                                        setCount(0);
                                        setShow(false);
                                    }}
                                >
                                    {count ? <span>{st('Clear')}</span> : <span>{st('None')}</span>}
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Filter;
